import PNotify from "../../../vendor/assets/javascripts/pnotify/pnotify";

globalThis.PNotify = PNotify;
